const Empty = require('constants/empty');
const Storage = require('utils/localStorage/Storage');

const TWENTY_FOUR_HOURS_IN_MILLISECONDS = 86400000;
const P13N_DATA = 'P13N_DATA';

const setPersonalizationKey = function (context) {
    return `${P13N_DATA}_${context}`;
};

const setPersonalizationCache = function (data) {
    data?.forEach(item => {
        const key = setPersonalizationKey(item?.p13n?.context);
        const expiry = item?.p13n?.isAbTest ? item?.p13n?.abTestEndDate : TWENTY_FOUR_HOURS_IN_MILLISECONDS;

        if (!Storage.local.getItem(key, false, true)) {
            Storage.local.setItem(key, item, expiry);
        }
    });
};

const getAllPersonalizedCache = function () {
    const cachedData = [];
    Object.keys(localStorage)
        .filter(key => key.startsWith(P13N_DATA))
        .forEach(key => {
            const cache = Storage.local.getItem(key, false, true);

            if (cache) {
                cachedData.push(cache);
            }
        });

    return cachedData;
};

const filteredCache = function (personalization) {
    let contextToReturn;
    const cachedData = getAllPersonalizedCache();
    const cachedItem = cachedData.filter(data => data.context === personalization.context)?.[0];

    if (cachedItem) {
        if (cachedItem.p13n?.abTestId && personalization.activeAbTestIds?.indexOf(cachedItem.p13n.abTestId) === -1) {
            contextToReturn = personalization.context;
        }
    } else {
        contextToReturn = personalization.context;
    }

    if (contextToReturn) {
        Storage.local.removeItem(setPersonalizationKey(contextToReturn));
    }

    return contextToReturn;
};

const getContextIdsToUpdate = items =>
    items.reduce((contextIds, item) => {
        if (item.personalization && item.personalization.isEnabled) {
            const filteredItem = filteredCache(item.personalization);

            if (filteredItem) {
                contextIds.push(item.personalization.context);
            }
        }

        (item.items || Empty.Array)
            .filter(({ personalization }) => personalization && personalization.isEnabled && personalization.context)
            .forEach(childItem => {
                const contextId = filteredCache(childItem.personalization);

                if (contextId) {
                    contextIds.push(contextId);
                }
            });

        return contextIds;
    }, []);

const getPersonalizationCache = function (context) {
    return Storage.local.getItem(setPersonalizationKey(context));
};

module.exports = {
    getContextIdsToUpdate,
    setPersonalizationCache,
    setPersonalizationKey,
    getPersonalizationCache,
    filteredCache,
    getAllPersonalizedCache
};
